<ngx-spinner bdColor='rgba(200,211,213,0.72)' size="medium" color="#3a6e9c" type="ball-fussion"></ngx-spinner>
